/**
 * Shared error handling utilities for error boundaries.
 * @module error/utils
 */

/**
 * Extracts a human-readable message from an unknown error type.
 * Handles Error objects, strings, and unknown values gracefully.
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'An unexpected error occurred';
}
/**
 * Firefox-specific Error properties.
 * Firefox augments Error instances with source-location fields not present in
 * the standard `Error` interface.
 */
export interface FirefoxError extends Error {
  fileName?: string;
  lineNumber?: number;
  columnNumber?: number;
}
